export default __webpack_public_path__ + "static/media/slide11.85ab58a2.jpg";